module.exports = __webpack_public_path__ + "static/media/german_infantry_120.60e76093.png";